<button
  class="edit-modify flex items-center justify-center"
  [pTooltip]="'SHARED.MODIFY' | translate"
  tooltipPosition="top"
  (click)="buttonClickEvent()"
  [disabled]="disabled"
>
  <img
    src="https://cdn.catexpert.ab-inbev.com/assets/images/icon-edit-black.svg"
    [ngStyle]="{
      width: iconSize ? iconSize : 'auto'
    }"
    alt="Edit"
  />
</button>
